import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import AdminDashboard from "./AdminDashboard";
import AgentDashboard from "./AgentDashboard";

class ParentDashboard extends Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("dashboard");
  }

  render() {
    return this.renderDashboard();
  }

  renderDashboard() {
    let { userType } = this.props.context.user;

    switch (userType) {
      case "SUPER":
        return <div></div>;
      case "ADMIN":
        return <AdminDashboard />;
      case "AGENT":
        return <AgentDashboard />;
      default:
        return <div></div>;
    }
  }
}

export default withSharedStateConsumer(withRouter(ParentDashboard));
